import { isServer } from 'solid-js/web';

let isVisregTest = false;
if (!isServer) {
    isVisregTest = window && window.location.href.includes('visreg');
}

export default isVisregTest;